module.exports = __webpack_public_path__ + "assets/freshteam.222e27b8.svg";